
<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-list {
  height: 300px; /* or any height you want */
  overflow-y: auto;
}
</style>


<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        จัดการข้อมูลโซน
      </div>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="850px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="success" elevation="0" v-bind="attrs" v-on="on" dark>
            <v-icon left>mdi-file-plus</v-icon>สร้างโซน
          </v-btn>
        </template>
        <ZoneForm></ZoneForm>
      </v-dialog>
    </v-layout>
    <v-divider class="my-4"></v-divider>
    <v-data-table :headers="headers" :items="zones" class="elevation-1">
      <template v-slot:item.ZTYPE="{ item }">
        {{item.ZTYPE | type_detail}}
      </template>
      <template v-slot:item.ID="{ item }">
       {{zones.map(function(x) {return x.ID; }).indexOf(item.ID) + 1}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ZoneForm from './forms/ZoneForm'
export default {
  components: {
    ZoneForm
  },
  name: "ManageZone",
  data: () => ({
    dialog: false,
    expanded: ['Donut'],
    singleExpand: false,
    headers: [
      {
        text: 'ลำดับ',
        align: 'left',
        sortable: false,
        value: 'ID',
        width:'3%'
      },
      { text: 'ชื่อโซน', value: 'Z_NAME',width:'20%' },
      { text: 'ข้อมูลพื้นที่', value: 'AREA' ,width:'5%' },
      { text: 'ประเภทโซน', value: 'ZTYPE',width:'10%' },
      { text: 'วันจัดเก็บ', value: 'DAYS',width:'10%' },
    ],

    zones: []

  }),
  watch: {},
  filters: {
    type_detail(item) {
      return item == "M" ? "รายเดือน" : "รายสัปดาห์"
    }
  },
  computed: {

  },
  mounted() { },
  created() {
    this.list_zone()
  },
  methods: {
    list_zone() {

      this.$token_api
        .get("/list-all-zone")
        .then((response) => {

          this.zones = response.data.data
        })
        .catch((err) => {

        });
    },
    clicked(value) {
      this.expanded.push(value)
    }
  },
};
</script>


